// Pure helpers for the convention prize lottery (webapp side). The draw itself
// lives server-side in backend/lib/convention-prizes.js.

// Norwegian list join: "A", "A og B", "A, B og C".
function joinNb(items) {
    if (items.length <= 1) return items.join('');
    return `${items.slice(0, -1).join(', ')} og ${items[items.length - 1]}`;
}

// Recipients for "SMS til vinnere": one sendSms-drawer user per winner holding
// at least one prize that is drawn and NOT picked up yet, with every such prize
// merged into {{premie}}. Phone: the user record loaded alongside the
// convention first, then the convention's participant snapshot. Winners
// without any phone are returned separately so the desk can reach them
// another way. Forfeited no-shows are never included.
export function buildPrizeWinnerSmsUsers(prizes, userRecords, participants, conventionTitle = '') {
    const byWinner = new Map();
    (Array.isArray(prizes) ? prizes : []).forEach((prize) => {
        if (!prize || !prize.winner || !(prize.winner.id > 0) || prize.claimed) return;
        const { winner } = prize;
        if (!byWinner.has(winner.id)) {
            byWinner.set(winner.id, {
                id: winner.id,
                firstname: String(winner.firstname || '').trim(),
                lastname: String(winner.lastname || '').trim(),
                titles: [],
            });
        }
        byWinner.get(winner.id).titles.push(String(prize.title || '').trim());
    });

    const phoneOf = (id) => {
        const user = (Array.isArray(userRecords) ? userRecords : []).find(u => u && u.id === id);
        if (user && user.cellphone) return String(user.cellphone).trim();
        const snap = (Array.isArray(participants) ? participants : []).find(p => p && p.id === id);
        return snap && snap.cellphone ? String(snap.cellphone).trim() : '';
    };

    const users = [];
    const noPhone = [];
    byWinner.forEach((w) => {
        const cellphone = phoneOf(w.id);
        if (!cellphone) {
            noPhone.push({ id: w.id, firstname: w.firstname, lastname: w.lastname });
            return;
        }
        users.push({
            id: w.id,
            firstname: w.firstname,
            lastname: w.lastname,
            cellphone,
            mergeFields: {
                fornavn: w.firstname,
                etternavn: w.lastname,
                premie: joinNb(w.titles.filter(Boolean)),
                stevne: conventionTitle || '',
            },
        });
    });
    return { users, noPhone };
}
